export type StartPage = 'home' | 'settings' | 'salon';

export function normalizeStartPage(value: unknown): StartPage {
    const raw = typeof value === 'string' ? value.trim().toLowerCase() : '';
    if (raw === 'settings') return 'settings';
    if (raw === 'salon') return 'salon';
    return 'home';
}

export function resolveStartPath(
    user: { start_page?: unknown; salon_enabled?: boolean; must_change_credentials?: boolean } | null | undefined
): string {
    if (user?.must_change_credentials) return '/';
    const startPage = normalizeStartPage(user?.start_page);
    if (startPage === 'settings') return '/settings';
    if (startPage === 'salon' && user?.salon_enabled) return '/salon';
    return '/';
}
